import { getCookie } from '../service/cookieService';
import { getAuthToken } from './appUtils';
import { getUserInfoFromServer } from './getUserInfo';

/**
 * @deprecated
 * use the function with same name inside
 * src/client/common/utils/browserUtils.js
 */
const isAgentLoggedin = function () {
  return isCustTypeAgent() || checkProfileTypeAgent();
};

/**
 * @deprecated
 * use the function with same name inside
 * src/client/common/utils/browserUtils.js
 */
const isCustTypeAgent = function () {
  const custType = getCookie('custType');
  const mmtAuth = getAuthToken();
  if (typeof mmtAuth !== 'undefined' && mmtAuth !== null && mmtAuth !== '') {
    if (
      typeof custType !== 'undefined' &&
      custType !== null &&
      (custType == 'agent' || custType == 'Agent')
    ) {
      return true;
    }
    return false;
  }
  return false;
};

const checkProfileTypeAgent = function () {
  const mmtAuth = getAuthToken();
  if (typeof mmtAuth !== 'undefined' && mmtAuth !== null && mmtAuth !== '') {
    const { profileType } = getUserInfoFromServer() || {};
    if (profileType && profileType === 'AGENT') {
      return true;
    }
  }
  return false;
};

const createUserDataFromLocalStorage = function () {
  return getUserInfoFromServer() || {};
};

export default {
  isAgentLoggedin,
  isCustTypeAgent,
  checkProfileTypeAgent,
  createUserDataFromLocalStorage,
};
